// TODO: check how the secureRoute features works in this case via modal.controllers and use it to simplify other instant uploaders.

module.exports = {
    extends: [
        '/',
        'base',
        'form',
        'media',
        'upload',
        'plupload',
        'plupload'
    ],

    config: {
        mode: 'instantUploader',
        autoOpenUploadDialog: true,
        isInstantUploader: true,
        showResultsContainer: true,
        // secureRoute: '/~/subscriberImporter',
        pluploaderConfig: {
            multi_selection: false,
            // url: '/LTR/~/subscriberImporter',
            // filters: {
            //     mime_types: [
            //         {
            //             title: 'Files',
            //             extensions: 'csv,xlsx'
            //         }
            //     ]
            // }
        }
    },
}